export const FormFieldValues = {
  Default: 'string',
  Custom: 'custom',
  Raw: 'raw',
  Select: 'select',
  Textarea: 'textarea',
  Password: 'password',
  Date: 'date',
  Checker: 'checker',
  Switch: 'switch',
  Boolean: 'boolean',
  Mask: 'mask',
  Divider: 'divider',
  Title: 'title',
  Document: 'document',
  Description: 'description',
  InfoDescription: 'infoDescription',
  Error: 'error',
  Email: 'email',
  Inn: 'inn',
  Group: 'group',
  Phone: 'phone',
} as const;
